import React from 'react'

function Logo() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2"
        y="2"
        width="36"
        height="36"
        rx="8"
        fill="#66d9ed"
        fillOpacity="0.1"
        stroke="#66d9ed"
        strokeWidth="2"
      />
      <text
        x="50%"
        y="55%"
        dominantBaseline="middle"
        textAnchor="middle"
        fill="#66d9ed"
        fontFamily="arial"
        fontWeight="700"
        fontSize="18"
      >
        {'<\\>'}
      </text>
    </svg>
  )
}

export default Logo
